const quantityBoomakerChanger = (value, dataOperation) => {
  let newDataOperation = [];
  const currentLength = dataOperation.length;
  if (value > currentLength) {
    const newItems = Array.from({ length: value - currentLength }, (_, i) => ({
      bet_home_name: `Casa De Aposta ${currentLength + i + 1}`,
      market_event: `Mercado ${currentLength + i + 1}`,
      info_market_event: `Informa\xE7\xE3o do Mercado ${currentLength + i + 1}`,
      commission: 0,
      chance: 2,
      stake: 0,
      backStake: 0,
      block_chance: false,
      block_stake: false,
      profit: 0
    }));
    newDataOperation = [...dataOperation, ...newItems];
  } else if (value < currentLength) {
    newDataOperation = dataOperation.slice(0, value);
  }
  return newDataOperation;
};
export {
  quantityBoomakerChanger
};